<div class="widget-container">
  <ion-grid>
    <ion-row class="close-row">
      <ion-col (click)="close()" class="close-col">
        <img src="../../../assets/icon/cancel.svg" alt="">
      </ion-col>
    </ion-row>
    <div>
      <ion-row class="header-row">
        <ion-col size="8">
          <div class="ion-text-start header-title">
            <ion-label> {{ 'Opportunities' | translate }}</ion-label>
          </div>
        </ion-col>
        <ion-col>
          <ion-searchbar [(ngModel)]="searchTerm" class="search-css" debounce="500" mode='ios'
            placeholder="{{ 'Start Typing...' | translate}}" [showCancelButton]="'never'" [showClearButton]="'never'"
            (ionChange)="opportunitySearch($event)">
          </ion-searchbar>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-card class="scrollVertical">
            <ion-row style="padding-left: 5%;padding-top: 2%;">
              <ion-col size="2.5">
                <ion-label class="cardContain-text">
                  {{ 'Opportunity Id' | translate }}
                </ion-label>
              </ion-col>
              <ion-col size="2.5">
                <ion-label class="cardContain-text">
                  {{ 'Project Id' | translate }}
                </ion-label>
              </ion-col>
              <ion-col size="5">
                <ion-label class="cardContain-text">
                  {{ 'Company Name' | translate }}
                </ion-label>
              </ion-col>
              <ion-col size="2">
                <ion-label class="cardContain-text">
                  {{ 'Status' | translate }}
                </ion-label>
              </ion-col>
            </ion-row>
            <ion-row class="labelBorder"></ion-row>
            <div *ngFor="let item of opportunityLists">
              <ion-row style=" padding-left: 5%;">
                <ion-col size="2.5">
                  <ion-label class="cardContain-Subtext" (click)="redirectToOffer(item)"
                    style="cursor: pointer;">
                    {{item.oppoId}}
                  </ion-label>
                </ion-col>
                <ion-col size="2.5">
                  <ion-label class="cardContain-Subtext1">
                    {{item.erp_Project_Id}}
                  </ion-label>
                </ion-col>
                <ion-col size="5">
                  <ion-label class="cardContain-Subtext1">
                    {{item.companyName}}
                  </ion-label>
                </ion-col>
                <ion-col size="2">
                  <ion-label class="cardContain-Subtext1">
                    {{item.status | translate}}
                  </ion-label>
                </ion-col>
              </ion-row>
            </div>
          </ion-card>
        </ion-col>
      </ion-row>
    </div>
  </ion-grid>
</div>